import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import api from 'brighteon/api';
import ImmutablePropTypes from 'react-immutable-proptypes';

export default @injectIntl
class OtherRepliedAccountsModal extends React.PureComponent {

  static propTypes = {
    onClose: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    status: ImmutablePropTypes.map,
  };

  state = {
    replies: [],
  }

  componentDidMount() {
    this.getReplies();
  }

  getReplies = () => {
    const { status } = this.props;
    api().get(`/api/v1/statuses/${status.get('id')}/replied_following_accounts_other`)
      .then(({ data }) => {
        this.setState({
          replies: data,
        });
      })
      .catch(err => {
        console.error(err);
      });
  }

  handleCancel = () => {
    this.props.onClose();
  }

  render() {
    const { replies } = this.state;

    return (
      <div className='modal-root__modal replies-modal'>
        <div className='replies-modal__container'>
          <div className='replies-modal__header'>
            <div className='d-flex justify-content-space-between'>
              <span>Following Replies</span>
              <span>
                <i
                  className='fa fa-times replies-modal__close'
                  onClick={this.handleCancel}
                  role='button' tabIndex={0}
                />
              </span>
            </div>
          </div>
          <div className='replies-modal__body'>
            {replies.map(reply => (
              <a
                href={reply.url}
                key={reply.id}
                className='replies-modal__reply-item'
              >
                <div
                  className='d-flex'
                >
                  <div
                    className='replies-modal__reply-avatar mr2'
                    style={{
                      backgroundImage: `url(${reply.avatar})`,
                    }}
                  />
                  <strong>
                    {reply.username}
                  </strong>
                  <span> </span>
                  <span>
                    @{reply.acct}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    );
  }

}
